<template>
	<TransitionRoot as="template" :show="show" :class="[ zIndex ]">
		<Dialog class="relative">
			<button v-if="preventAutoFocus" autofocus class="sr-only">Hidden anchor</button>
			<TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
				<div class="flex fixed inset-0 w-screen overflow-y-auto bg-primary-darker" :class="[ bgOpacity ]">
					<div class="flex items-center" :class="[horizontalAlignment, verticalAlignment, horizontalSize, verticalSize, paddingClasses]">
						<DialogPanel class="relative h-full w-full transform overflow-hidden rounded-xl p-6 bg-neutral shadow-xl transition-all" :class="borderClasses">
							<slot></slot>
						</DialogPanel>
					</div>
				</div>
			</TransitionChild>
		</Dialog>
	</TransitionRoot>
</template>

<script setup lang="js">
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { ModalHorizontalAlignment, ModalVerticalAlignment } from '@/components/Alerts/ModalAlignment.js'
import { ModalHorizontalSize, ModalVerticalSize } from '@/components/Alerts/ModalSize.js'

defineProps({
	show: { type: Boolean, default: false },
	bgOpacity: { type: String, default: 'bg-opacity-45' },
	borderClasses: { type: String, default: '' },
	paddingClasses: { type: String, default: '' },
	zIndex: { type: String, default: 'z-999999' },
	horizontalAlignment: {
		type: String,
		default: ModalHorizontalAlignment.Center
	},
	verticalAlignment: {
		type: String,
		default: ModalVerticalAlignment.Center
	},
	horizontalSize: {
		type: String,
		default: ModalHorizontalSize.Fit
	},
	verticalSize: {
		type: String,
		default: ModalVerticalSize.Fit
	},
	preventAutoFocus: { type: Boolean, default: false }
})

</script>